import { Injectable } from "@angular/core";
import { MonitoringService } from "../AppInsights/monitoring-service";
import { Rodeo } from "../../model/rodeo";
import { RodeoEvent } from "../../model/rodeoEvent";
import { PayoutConfig } from "../../model/payoutConfig";
import { RodeoPointSeriesNominationsDto } from "../../lib/types/RodeoPointSeriesNominationsDto";

@Injectable()
export class PointsMonitoringService {
    constructor(private monitoringService: MonitoringService) { }

    logVerifyPointsStatus(rodeo: Rodeo, rodeoEvent: RodeoEvent, payouts: PayoutConfig[]) {
        let eventName = this.generateEventName('Starting points verification for Rodeo:', rodeo, rodeoEvent);
        this.monitoringService.logEvent(eventName, {
            payouts: this.formatPayouts(payouts),
        })
    }

    logVerifyPointsStatusResult(rodeo: Rodeo, rodeoEvent: RodeoEvent, payouts: PayoutConfig[], verificationResult) {
        let eventName = this.generateEventName('Points verification results for Rodeo:', rodeo, rodeoEvent);
        this.monitoringService.logEvent(eventName, {
            payouts: this.formatPayouts(payouts),
            verificationResult: { ...verificationResult, validPayoutConfig: this.formatPayouts(verificationResult.validPayoutConfig) },
        })
    }

    logPointStatsGeneratingStart(
        rodeo: Rodeo, rodeoEvent: RodeoEvent, payouts: PayoutConfig[],
        useScoreValue: boolean, rodeoPointSeriesNominations: RodeoPointSeriesNominationsDto[]
    ) {
        let eventName = this.generateEventName('Starting points generation for Rodeo:', rodeo, rodeoEvent);
        this.monitoringService.logEvent(eventName, {
            payouts: this.formatPayouts(payouts),
            useScoreValue: useScoreValue,
            rodeoPointSeriesNominations: rodeoPointSeriesNominations,
        });
    }

    logGeneratedPointStats(rodeo: Rodeo, rodeoEvent: RodeoEvent, payouts: PayoutConfig[], useScoreValue: boolean, generatedPointStats, rodeoPointSeriesNominations: RodeoPointSeriesNominationsDto[]) {
        let eventName = this.generateEventName('Generated points for Rodeo:', rodeo, rodeoEvent);
        this.monitoringService.logEvent(eventName, {
            payouts: this.formatPayouts(payouts),
            useScoreValue: useScoreValue,
            generatedPointStats: generatedPointStats,
            rodeoPointSeriesNominations: rodeoPointSeriesNominations,
        })
    }

    private generateEventName(baseEventName: string, rodeo: Rodeo, rodeoEvent: RodeoEvent) {
        let eventName = baseEventName;
        eventName += `${rodeo.name} - ${rodeoEvent.displayName}`;
        return eventName;
    }

    private formatPayouts(payouts: PayoutConfig[]): PayoutConfig[] {
        // payout format takes to much space and I don't reallry need it for the logs
        return payouts.map(p => ({ ...p, payoutFormat: null }))
    }
}


// WEBPACK FOOTER //
// ./src/services/points/points.monitoring.service.ts